import { FileText, Plus } from "lucide-react";

/**
 * SalesToolbar
 * ------------
 * First slice of the Sales.jsx refactor (iter 57.54).  Pulls the header
 * button-strip out of the 770-line Sales page so the parent stays focussed
 * on data fetching + table rendering.  Row markup remains in the parent so
 * we don't have to thread every editor callback through.
 *
 * Every button keeps its existing data-testid so all currently-passing
 * end-to-end tests keep working without any script edit.
 */
export default function SalesToolbar({
  channel, setChannel,
  partnerFilter, setPartnerFilter, partners,
  tab, setTab,
  fy, setFy, fyOptions,
  selectedSize,
  onNewStandalone, onGenBatch, onGenBatchZip,
}) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <button data-testid="sales-new-standalone" onClick={onNewStandalone}
        className="text-sm px-3 py-2 border border-brand text-brand rounded-md hover:bg-[color:var(--aii-green-tint)] font-semibold flex items-center gap-1.5">
        <Plus size={14}/> New invoice
      </button>
      {selectedSize >= 2 && (
        <button data-testid="sales-batch-invoice" onClick={onGenBatch}
          className="text-sm px-3 py-2 bg-brand text-white rounded-md hover:bg-brand-dark font-semibold flex items-center gap-1.5">
          <FileText size={14}/> Combined ({selectedSize})
        </button>
      )}
      {selectedSize >= 1 && (
        <button data-testid="sales-batch-zip" onClick={onGenBatchZip}
          className="text-sm px-3 py-2 border border-brand text-brand rounded-md hover:bg-[color:var(--aii-green-tint)] font-semibold flex items-center gap-1.5">
          <FileText size={14}/> ZIP invoices ({selectedSize})
        </button>
      )}
      <div className="inline-flex rounded-md border border-[color:var(--aii-border)] overflow-hidden" data-testid="sales-channel">
        {[["all","All"],["program","Programs"],["weekend","Weekends"],["partner","By Partner"]].map(([k, label]) => (
          <button key={`ch-${k}`} data-testid={`sales-channel-${k}`}
                  onClick={() => { setChannel(k); try { localStorage.setItem("aii-sales-channel", k); } catch { /* ignore */ } }}
                  className={`px-2.5 py-1.5 text-xs font-semibold ${channel === k ? "bg-brand text-white" : "bg-white text-[color:var(--aii-text-2)] hover:bg-slate-50"}`}>
            {label}
          </button>
        ))}
      </div>
      <select data-testid="sales-partner-filter" value={partnerFilter}
              onChange={e => setPartnerFilter(e.target.value)}
              title="Zoom into a single partner's sales"
              className={`px-2.5 py-1.5 text-xs font-semibold border rounded-md ${partnerFilter ? "border-brand bg-[color:var(--aii-green-tint)] text-brand" : "border-[color:var(--aii-border)] bg-white text-[color:var(--aii-text-2)]"}`}>
        <option value="">All partners</option>
        {partners.map(p => <option key={`pf-${p.id}`} value={(p.company_name || p.name || "").toLowerCase()}>{p.company_name || p.name}</option>)}
      </select>
      <div className="inline-flex rounded-md border border-[color:var(--aii-border)] overflow-hidden">
        <button data-testid="sales-tab-active" onClick={()=>setTab("active")} className={`px-3 py-1.5 text-sm font-semibold ${tab==="active"?"bg-brand text-white":"bg-white"}`}>Active</button>
        <button data-testid="sales-tab-past" onClick={()=>setTab("past")} className={`px-3 py-1.5 text-sm font-semibold ${tab==="past"?"bg-brand text-white":"bg-white"}`}>Past</button>
      </div>
      <select data-testid="sales-fy" value={fy} onChange={e=>setFy(e.target.value)} className="px-3 py-1.5 border border-[color:var(--aii-border)] rounded-md bg-white text-sm font-semibold">
        {fyOptions().map(y => <option key={y} value={y}>FY {y}</option>)}
        <option value="all">All-time</option>
      </select>
    </div>
  );
}
